import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UnapprovedVendor from './UnapprovedVendor';
import RejectedVendor from './RejectedVendor';
import UnexpectedError from './UnexpectedError';
import ProfileNavBar from './Components/ProfileNavBar/ProfileNavBar';
import Sidebar from './SideBar';
import APIProgram from './Components/APIProgram/APIProgram';
import Dashboard from './Components/Dashboard/Dashboard';
import Listings from './Components/Listings/Listings';
import Orders from './Components/Orders/Orders';
import Reviews from './Components/Reviews/Reviews';
import Documents from './Components/Documents/Documents';
import InviteTeammate from './Components/TeamManagement/InviteTeammate';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { useUser } from '../../UserContext';
import { DASHBOARD_ICON, LISTINGS_ICON, ORDERS_ICON, REVIEWS_ICON, DOCUMENTATION_ICON, API_ICON, INVITE_ICON } from './Icons';

// Common CSS classes
const styles = {
    container: 'min-h-screen w-full flex flex-col bg-marketplaceBackground overflow-hidden',
    loadingText: 'text-center mt-4',
    unauthorizedText: 'text-red-500 text-center mt-4',
    mainContent: 'flex flex-row flex-grow h-full',
    contentContainer: 'flex-grow ml-[5rem] sm:ml-[27rem] p-2 px-4 overflow-y-auto h-full',
};

const VendorProfile = ({ category }) => {
    const { isSignedIn, userPermissions } = useUser();
    const [userType, setUserType] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('');
    const navigate = useNavigate();
    const [buttonLabels, setButtonLabels] = useState([
        "Dashboard",
        "Listings",
        "Orders",
        "Reviews",
        "API Program",
        "Users"
    ]);


    const buttonUrls = {
        "Dashboard": "/vendors/profile/dashboard",
        "Listings": "/vendors/profile/listings",
        "Orders": "/vendors/profile/orders",
        "Reviews": "/vendors/profile/reviews",
        "API Program": "/vendors/profile/api-program",
        "Users": "/vendors/profile/invite-teammate"
    };

    const buttonIcons = {
        "Dashboard": DASHBOARD_ICON,
        "Listings": LISTINGS_ICON,
        "Orders": ORDERS_ICON,
        "Reviews": REVIEWS_ICON,
        "Documents": DOCUMENTATION_ICON,
        "API Program": API_ICON,
        "Users": INVITE_ICON
    };



    const fetchAttributes = async () => {
        if (isSignedIn) {
            const userAttributes = await fetchUserAttributes(['custom:userType']);
            if (userAttributes) {
                setUserType(userAttributes['custom:userType']);
            }
        }
    };

    useEffect(() => {
        fetchAttributes();
        setSelectedCategory(category);
    }, [category]);

    const handleCategoryChange = (categoryVal) => {
        setSelectedCategory(categoryVal);
        navigate(buttonUrls[categoryVal], { replace: false });
    };

    const renderComponent = () => {
        switch (selectedCategory) {
            case 'Dashboard':
                return (
                    <>
                        <ProfileNavBar heading="Dashboard" />
                        <Dashboard />
                    </>
                );
            case 'Listings':
                return (
                    <>
                        <ProfileNavBar heading="Your Listings" />
                        <Listings />
                    </>
                );
            case 'Orders':
                return (
                    <>
                        <ProfileNavBar heading="Your Orders" />
                        <Orders />
                    </>
                );
            case 'Reviews':
                return (
                    <>
                        <ProfileNavBar heading="Your Reviews" />
                        <Reviews />
                    </>
                );
            case 'API Program':
                return (
                    <>
                        <ProfileNavBar heading="API Program" />
                        <APIProgram />
                    </>
                );
            case 'Users':
                return (
                    <>
                        <ProfileNavBar heading="Users" />
                        <InviteTeammate />
                    </>
                );
            case 'UNAPPROVED':
                return (
                    <>
                        {/* <ProfileNavBar heading="Unapproved" />
                        <div className={styles.unauthorizedText}>Your account is not approved yet.</div> */}
                    </>
                );
            case 'REJECTED':
                return (
                    <>
                        {/* <ProfileNavBar heading="Rejected" />
                        <div className={styles.unauthorizedText}>Your account is not approved yet.</div> */}
                    </>
                );
            case 'UNEXPECTEDERROR':
                return (
                    <>

                    </>
                );
            default:
                return (
                    <>
                        <ProfileNavBar heading="Dashboard" />
                        <Dashboard />
                    </>
                );
        }
    };

    if (userType === 'admin') {
        return (
            <div className={styles.container}>
                <div className={styles.unauthorizedText}>You are not authorized to see this.</div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            {
                category === 'UNAPPROVED' ?
                    <UnapprovedVendor />
                    :
                    category === 'REJECTED' ?
                        <RejectedVendor status={"REJECTED"} />
                        :
                        category === 'DEACTIVATED' ?
                            <RejectedVendor status={"DEACTIVATED"} />
                            :
                            category === 'UNEXPECTEDERROR' ?
                                <UnexpectedError />
                                :
                                <div className={styles.mainContent}>
                                    <div className='flex-shrink-0 fixed h-full'>
                                        <Sidebar
                                            navigate={navigate}
                                            buttonLabels={buttonLabels}
                                            selectedCategory={selectedCategory}
                                            handleCategoryChange={handleCategoryChange}
                                            buttonIcons={buttonIcons}
                                        />
                                    </div>
                                    <div className={styles.contentContainer}>
                                        {renderComponent()}
                                    </div>
                                </div>
            }

        </div>
    );
};

export default VendorProfile;
